import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class MLoginIdService {
  private static readonly M_LOGIN_ID_KEY = 'MLoginId';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): string {
    return this.storage.get(MLoginIdService.M_LOGIN_ID_KEY);
  }

  public set(mLoginId: string) {
    this.storage.set(MLoginIdService.M_LOGIN_ID_KEY, mLoginId);
  }

  public remove() {
    this.storage.remove(MLoginIdService.M_LOGIN_ID_KEY);
  }
}
